import React, { useRef, useEffect, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const HelpDisk = props => {
    const [anchorElDetailsMenu, setanchorElDetailsMenu] = React.useState(null);
    const openDetailsMenu = Boolean(anchorElDetailsMenu);
    const handleClickDetailsMenu = (event) => {        
        setanchorElDetailsMenu(event.currentTarget);
    };
    const handleCloseDetailsMenu = () => {
        setanchorElDetailsMenu(null);
    }
    return (
        <>
            <IconButton
            className='btn-help-disk'
            aria-label="more"
            id={"btn-help-disk"}
            aria-controls={"menu-help-disk"}
            aria-expanded={openDetailsMenu ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClickDetailsMenu}
            style={{}}            
            >?</IconButton>  
            <Menu                        
                id={"menu-help-disk"}
                MenuListProps={{
                'aria-labelledby': "btn-help-disk",
                'class':'menu-details-pnl menu-help-disk-cls'
                }}
                anchorEl={anchorElDetailsMenu}
                open={openDetailsMenu}
                onClose={handleCloseDetailsMenu}
                PaperProps={{
                style: {
                    maxHeight: 48 * 4.5,
                    maxWidth: '208px',
                    padding:'0px',
                    background: '#FFFFFF',
                    borderRadius: '6px',
                    boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)'
                },
                }}
            >
                <MenuItem key={0} onClick={()=>{window.open('https://intercom.help/DataPointApp/en', '_blank')}}>
                    <img src={require('../../assets/icons/help-disk-help.svg')}  /> Help center
                </MenuItem>
                <MenuItem key={1} className='disk-help-show' onClick={handleCloseDetailsMenu}>
                    <img src={require('../../assets/icons/help-disk-send-messges.svg')}  /> Send message
                </MenuItem>
                <MenuItem className="divider"></MenuItem> 
                <MenuItem key={2} onClick={()=>{window.open('https://datapoint.notion.site/Release-Notes-5b2756036f3d4ca19712423a5db5c141', '_blank')}}>
                    <img src={require('../../assets/icons/help-disk-news.svg')}  /> What’s new
                </MenuItem>
                <MenuItem key={3} onClick={()=>{window.open('https://www.qualitycounts.net/Aboutus/careers', '_blank')}}>
                    <img src={require('../../assets/icons/help-disk-join.svg')}  /> Join us
                </MenuItem>
                <MenuItem className="divider"></MenuItem> 
                <MenuItem key={4} onClick={()=>{window.open('https://www.data-point.io/tos-privacy-policy', '_blank')}}>
                    <img src={require('../../assets/icons/help-disk-privacy-policy.svg')}  /> ToS & privacy policy
                </MenuItem>                           
            </Menu>
        </>
    )

}

export default HelpDisk;